import { Authority } from '@/shared/security/authority';

const Register = () => import('@/account/register/register.vue');
const RegisterInfo = () => import('@/account/register/register-info.vue');
const RegisterNioAdmin = () => import('@/account/register-nio-admin/register-nio-admin.vue');
const RegisterNioSuperAdmin = () => import('@/account/register-nio-super-admin/register-nio-super-admin.vue');
const RegisterCompanyOrgAdmin = () => import('@/account/register-company-org-admin/register-company-org-admin.vue');
const RegisterCompanyUser = () => import('@/account/register-company-user/register-company-user.vue');
const RegisterCompanyAdmin = () => import('@/account/register-company-admin/register-company-admin.vue');
const RegisterCompanySuperAdmin = () => import('@/account/register-company-super-admin/register-company-super-admin.vue');
const RegisterNioOrgAdmin = () => import('@/account/register-nio-org-admin/register-nio-org-admin.vue');
const SpecialAuth = () => import('@/account/special-auth/special-auth.vue');
// const confirmAccountData = () => import('@/account/register/confirm-account-data.vue');
const Activate = () => import('@/account/activate/activate.vue');
const ResetPasswordInit = () => import('@/account/reset-password/init/reset-password-init.vue');
const ResetPasswordFinish = () => import('@/account/reset-password/finish/reset-password-finish.vue');
const ChangePassword = () => import('@/account/change-password/change-password.vue');
const Settings = () => import('@/account/settings/settings.vue');
const B2BSettings = () => import('@/account/settings/b2b-settings.vue');
const MeetingAccept = () => import('@/account/meeting-accept/meeting-accept.vue');
const AdvertisementSupporterAccept = () => import('@/account/advertisement-supporter-accept/advertisement-supporter-accept.vue');

export default [
  {
    path: '/register',
    name: 'Register',
    component: Register,
  },
  {
    path: '/register-nio-admin',
    name: 'RegisterNioAdmin',
    component: RegisterNioAdmin,
  },
  {
    path: '/register-nio-super-admin',
    name: 'RegisterNioSuperAdmin',
    component: RegisterNioSuperAdmin,
  },
  {
    path: '/register-company-org-admin',
    name: 'RegisterCompanyOrgAdmin',
    component: RegisterCompanyOrgAdmin,
  },
  {
    path: '/register-company-user',
    name: 'RegisterCompanyUser',
    component: RegisterCompanyUser,
  },
  {
    path: '/register-invited-company-admin',
    name: 'RegisterCompanyAdmin',
    component: RegisterCompanyAdmin,
  },
  {
    path: '/register-company-super-admin',
    name: 'RegisterCompanySuperAdmin',
    component: RegisterCompanySuperAdmin,
  },
  {
    path: '/register-nio-org-admin',
    name: 'RegisterNioOrgAdmin',
    component: RegisterNioOrgAdmin,
  },
  {
    path: '/special-auth',
    name: 'SpecialAuth',
    component: SpecialAuth,
  },
  // {
  //   path: '/b2b/register/confirm',
  //   name: 'confirmAccountData',
  //   component: confirmAccountData,
  //   meta: { authorities: [Authority.USER] },
  // },'
  {
    path: '/register-info',
    name: 'RegisterInfo',
    component: RegisterInfo,
  },
  {
    path: '/b2b/register-info',
    name: 'B2BRegisterInfo',
    component: RegisterInfo,
  },
  {
    path: '/account/activate',
    name: 'Activate',
    component: Activate,
  },
  {
    path: '/account/reset/request',
    name: 'ResetPasswordInit',
    component: ResetPasswordInit,
  },
  {
    path: '/account/reset/finish',
    name: 'ResetPasswordFinish',
    component: ResetPasswordFinish,
  },
  {
    path: '/account/password',
    name: 'ChangePassword',
    component: ChangePassword,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/account/settings',
    name: 'Settings',
    component: Settings,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/b2b/account/settings',
    name: 'B2BSettings',
    component: B2BSettings,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/b2b/meeting-accept',
    name: 'MeetingAccept',
    component: MeetingAccept,
    meta: { authorities: [Authority.USER] },
  },

  {
    path: '/b2b/advertisement-supporter-accept',
    name: 'AdvertisementSupporterAccept',
    component: AdvertisementSupporterAccept,
    meta: { authorities: [Authority.USER] },
  },
];
